export default function listing() {

  $('[data-gallery-listing]').slick({
    arrows: true,
    infinite: false,
    prevArrow: '<div class="slick-prev"><i class="fal fa-chevron-left"></i></div>',
    nextArrow: '<div class="slick-next"><i class="fal fa-chevron-right"></i></div>',
  });

}



// WEBPACK FOOTER //
// ./scripts/modules/listing.js